<template>
    <div>
        <div style="margin: 0 auto; max-width: 500px;">
            <div class="sys-device-title">{{ $t('client.device.importDeviceInform') }}</div>

            <div class="sys-device-warpper">
                <div class="sys-site-title"> Client Name {{ brandName }} </div>

                <template v-for="(item, index) in deviceList">
                    <ImportDeviceComponent :ref="'deviceRef' + index" :index="index" @deleteData="deleteData"
                        :outletList="outletList">
                    </ImportDeviceComponent>
                </template>
            </div>
        </div>
        <div class="sys-device-fixed-btn">
            <el-button @click="addData" class="sys-btn-default">+{{ $t('common.create') }}</el-button>
            <el-button @click="saveData" type="primary">{{ $t('common.confirm') }}</el-button>
        </div>
    </div>
</template>

<script>

import ImportDeviceComponent from "./components/importDeviceComponent.vue";
export default {
    components: {
        ImportDeviceComponent
    },
    data() {
        return {
            deviceList: [],
            outletList: [],
            currentBrandId: null,
            monitorId: null,
        }
    },
    async created() {
        let { currentBrandId, monitorId, brandName, token } = this.$route.query;
        console.log(token)
        if (currentBrandId && monitorId && brandName && token) {
            sessionStorage.setItem('tempToken', token);
            this.currentBrandId = Number(currentBrandId);
            this.monitorId = Number(monitorId);
            this.brandName = brandName;
            await this.settingGetCameraList(token);
            this.deviceList = [1];

        } else {
            this.$message.error(this.$t('client.device.checkLink'));
        }
    },
    mounted() {
        document.getElementsByTagName('html')[0].style.background = "#f0f3f8";
    },
    methods: {
        async settingGetCameraList(token) {
            let res = await this.$Http.get(this.$Api.settingGetCameraList + '/' + this.currentBrandId, true, token);
            if (res.success) {
                this.outletList = res.result;
            }
        },
        addData() {
            this.deviceList.push(1);
        },
        deleteData(index) {
            this.deviceList.splice(index, 1);
        },
        saveData() {
            let list = [], flag = false;
            this.deviceList.forEach((item, index) => {
                let result = this.$refs['deviceRef' + index][0].validFormData();
                if (result.flag) {
                    list.push(result.data);
                } else {
                    flag = true;
                }
            });
            if (flag) {
                return false;
            }
            this.$Http.post(this.$Api.deviceImportDevice + '/' + this.monitorId, list).then(res => {
                if (res.success) {
                    this.$message.success(this.$t('common.successful'));
                    location.reload();
                }
            });
        }
    }
}
</script>

<style scoped>
.sys-device-title {
    margin: 30px 0 30px 30px;
    font-size: 16px;
    font-weight: bold;
    color: #5B647D;
}

.sys-device-warpper {
    background: #fff;
    border-radius: 6px 6px 0px 6px;
    margin: 0 20px 80px 20px;
    padding: 15px;
    display: inline-block;
    width: calc(100% - 40px)
}

.sys-site-title {
    font-weight: bold;
    padding: 0 0 17px 0;
    font-size: 14px;
    color: #0B73F6;
    border-bottom: 1px dashed #F0F3F8;
}

.sys-device-fixed-btn {
    z-index: 9999;
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 100%;
    background: rgb(240, 243, 248);
    padding: 20px 0;
}
</style>